module.exports = __webpack_public_path__ + "img/IMG_1325.b25f5f67.jpeg";